'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _themeA11y = require('@shopify/theme-a11y');

var a11y = _interopRequireWildcard(_themeA11y);

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('../helpers/utils');

var _bind = require('../mixins/bind');

var _bind2 = _interopRequireDefault(_bind);

var _escEvent = require('../mixins/esc-event');

var _escEvent2 = _interopRequireDefault(_escEvent);

var _overlay = require('../mixins/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Export default toggle module.
 */
/**
 * Component: Toggle
 * ------------------------------------------------------------------------------
 * A accessible function to trigger a toggle-able component with a window overlay.
 *
 * @namespace Toggle
 *
 */
exports.default = function (config) {

  /**
   * Instance default settings.
   */
  var defaults = {
    overlay: true,
    focusInput: true
  };

  /**
   * Instance settings.
   */
  var settings = (0, _utils.extendDefaults)(defaults, config);
  var namespace = config.namespace || config.targetSelector;

  /**
   * Node selectors.
   */
  var nodeSelectors = {
    toggleSelector: document.querySelectorAll('[js-toggle="' + config.toggleSelector + '"]'),
    targetSelector: document.querySelectorAll('[js-toggle="' + config.targetSelector + '"]')
  };

  /**
   * Initialise component bind to prevent double binds.
   */
  var binder = (0, _bind2.default)(nodeSelectors.targetSelector, {
    className: 'toggle-set'
  });

  /**
   * Initiate component.
   */
  function init() {
    if (binder.isSet()) {
      return;
    }

    setToggleEvents();
    setListeners();
    binder.set();
  }

  /**
   * Set component listeners.
   */
  function setListeners() {
    Frame.EventBus.listen(['EscEvent:on', 'Overlay:' + namespace + ':hide'], function () {
      close();
    });
  }

  /**
   * Set click events on toggle selectors.
   */
  function setToggleEvents() {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.toggleSelector)).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleToggleEvent(event);
      });
    });
  }

  /**
   * Handle toggle events.
   * @param {Event} event Click event.
   */
  function handleToggleEvent(event) {
    event.preventDefault();
    toggle();
  }

  /**
   * Toggle target component.
   */
  function toggle() {
    return isTargetActive() ? close() : open();
  }

  /**
   * Open target component and fire global open event.
   */
  function open() {
    addSelectorClasses();
    (0, _escEvent2.default)().set();
    focusTarget();

    if (settings.overlay) {
      (0, _overlay2.default)({ namespace: namespace }).open();
    }

    Frame.EventBus.emit('Toggle:' + namespace + ':open');
  }

  /**
   * Close target component and fire global close event.
   */
  function close() {
    removeSelectorClasses();
    unfocusTarget();

    if (settings.overlay) {
      (0, _overlay2.default)({ namespace: namespace }).close();
    }

    Frame.EventBus.emit('Toggle:' + namespace + ':close');
  }

  /**
   * Set toggle and target states active.
   */
  function addSelectorClasses() {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.targetSelector)).forEach(function (element) {
      element.classList.add(_cssClasses2.default.active);
    });

    [].concat((0, _toConsumableArray3.default)(nodeSelectors.toggleSelector)).forEach(function (element) {
      element.classList.add(_cssClasses2.default.active);
    });
  }

  /**
   * Remove active classes from all toggles and targets.
   */
  function removeSelectorClasses() {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.targetSelector)).forEach(function (element) {
      element.classList.remove(_cssClasses2.default.active);
    });

    [].concat((0, _toConsumableArray3.default)(nodeSelectors.toggleSelector)).forEach(function (element) {
      element.classList.remove(_cssClasses2.default.active);
    });
  }

  /**
   * Check if target is active.
   */
  function isTargetActive() {
    return [].concat((0, _toConsumableArray3.default)(nodeSelectors.targetSelector)).every(function (element) {
      return element.classList.contains(_cssClasses2.default.active);
    });
  }

  /**
   * Set a11y focus on first target.
   */
  function focusTarget() {
    if (settings.focusInput && targetHasInput(nodeSelectors.targetSelector[0])) {
      a11y.trapFocus(nodeSelectors.targetSelector[0].querySelector('input'));
      return;
    }

    a11y.trapFocus(nodeSelectors.targetSelector[0]);
  }

  /**
   * Check if focus has an input to focus on.
   */
  function targetHasInput(target) {
    return target.querySelector('input');
  }

  /**
   * Remove a11y focus on target.
   */
  function unfocusTarget() {
    a11y.removeTrapFocus(nodeSelectors.targetSelector[0]);
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init: init,
    open: open,
    close: close
  });
};